import { Link } from 'react-router-dom';
import { getLatestArticles, getPopularArticles, type Article } from '@/mocks/articles';

function ArticleCard({ article }: { article: Article }) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 hover:-translate-y-1"
    >
      <div className="relative w-full aspect-video overflow-hidden">
        <img
          src={article.coverImage}
          alt={article.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 bg-black/60 backdrop-blur-sm text-white text-xs rounded-full whitespace-nowrap">
            {article.duration}
          </span>
        </div>
        <div className="absolute top-3 right-3">
          <span className="px-2 py-1 bg-primary-500 text-white text-xs rounded-full whitespace-nowrap font-medium">
            {article.quality}
          </span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors">
          {article.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-3">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" />
            {(article.readCount / 10000).toFixed(1)}万
          </span>
          <span>{article.publishDate}</span>
        </div>
      </div>
    </Link>
  );
}

export default function FeaturedContent() {
  const latestArticles = getLatestArticles(6);
  const popularArticles = getPopularArticles(6);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-12">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                最新上线
              </h2>
              <p className="text-sm text-foreground-500 mt-2">最热最新的视频内容，不错过每一个精彩</p>
            </div>
            <Link
              to="/category/dianying"
              className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {latestArticles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                热门推荐
              </h2>
              <p className="text-sm text-foreground-500 mt-2">千万用户正在观看的热门内容</p>
            </div>
            <Link
              to="/category/zongyi"
              className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {popularArticles.map((article) => (
              <ArticleCard key={`popular-${article.id}`} article={article} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}